import React from 'react'
import { Button } from '@paypalcorp/pp-react'
import './login-button.css'
import { Link } from 'gatsby'

// TODO: remove commented code

// const renderLogInBtn = (loginURL) => {
//   return (
//     <Button className={loginButton} data-js="auth-btn" href={loginURL} data-dxa="login,nav-click,nav-login">Log Into Dashboard</Button>
//     // <div className="dx-auth-logged-out">
//     //   <a className="dx-auth-login dx-btn dx-btn-primary" data-js="auth-btn" href={loginURL} data-dxa="login,nav-click,nav-login">Log into Dashboard</a>
//     // </div>
//   )
// }

interface LoginButtonProps {
  user?: any
  loginURL?: any
  searchID?: string
}

const LoginButton: React.FC<LoginButtonProps> = ({
  user = {},
  loginURL = {},
  searchID = '',
}) => {
  const fptiData = typeof window !== `undefined` && window.fpti
  const queryString =
    typeof window !== 'undefined' ? window.location.search : ''
  const searchParams = new URLSearchParams(queryString)
  const aiQueryParam = searchParams.get('gen_ai_summary')

  const onLoginClick = (e) => {
    if (fptiData && aiQueryParam === 'true') {
      const options = {
        data: {
          page: fptiData && fptiData.page,
          pgrp: fptiData && fptiData.pgrp,
          component: 'devdiscoverynodeweb',
          name: 'gen_ai_summary',
          searchID,
          tag: 'login-to-dashboard-click',
          link: loginURL,
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.recordClick(options)
      }
    }
  }
  const loginContainerClassName = [
    'dx-auth-block container-login profile__container',
    user.loggedIn ? 'dx-authed' : '',
  ]
    .join(' ')
    .trim()

  return (
    <div>
      <div className={loginContainerClassName}>
        <Button
          as="a"
          data-js="auth-btn"
          className="login_btn"
          href={loginURL}
          size="sm"
          data-dxa="login,nav-click,nav-login"
          onClick={(e) => {
            onLoginClick(e)
          }}
        >
          Log in to Dashboard
        </Button>
      </div>
    </div>
  )
}

export default LoginButton
